import { FilterOperators } from "@crispico/foundation-gwt-js";
import { EntityDescriptor, EntityTablePage, EntityTablePageProps, EntityTablePageReducers, EntityTablePageState, FieldDescriptor, Utils } from "@crispico/foundation-react";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { DatePickerFieldEditor } from "@crispico/foundation-react/entity_crud/fieldEditors/DatePickerFieldEditor";
import DateFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/DateFieldRenderer";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { TerritoriesFieldDescriptor } from "pages/EquipmentResource/EquipmentResourceUtils";

export class DetectionEventEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "DetectionEvent",
            miniFields: ["id"],
            defaultSort: { field: "date", direction: "DESC" },
            defaultFilter: Filter.createForClient("date", FilterOperators.forDate.today),
            icon: "rss"
        });
    }

    protected customize() {
        this.isInDefaultColumnConfig(true, "equipmentResource", "detectedBy", "date", "longitude", "latitude", "territories", "enteredTerritories", "exitedTerritories")
            .addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
            .addFieldDescriptor({ name: "equipmentResource", type: "EquipmentResource" })
            .addFieldDescriptor({ name: "detectedBy", type: "EquipmentResource" })
            .addFieldDescriptor({
                name: "date",
                type: FieldType.date,
                additionalFieldEditorProps: FieldDescriptor.castAdditionalFieldEditorProps(DatePickerFieldEditor, { format: Utils.dateTimeWithSecFormat }),
                additionalFieldRendererProps: FieldDescriptor.castAdditionalFieldRendererProps(DateFieldRenderer, { format: Utils.dateTimeWithSecFormat })
            })
            .addFieldDescriptor({ name: "latitude", type: FieldType.double })
            .addFieldDescriptor({ name: "longitude", type: FieldType.double })
            .addFieldDescriptor(new TerritoriesFieldDescriptor("territories"))
            .addFieldDescriptor(new TerritoriesFieldDescriptor("enteredTerritories"))
            .addFieldDescriptor(new TerritoriesFieldDescriptor("exitedTerritories"))
    }

    renderTable() {
        return <DetectionEventTablePageRRC {...super.renderTable().props} ref={this.entityTablePage} />;
    }
}

class DetectionEventTablePage extends EntityTablePage<EntityTablePageProps> {

    addOneToManyModeFilters(filters: Filter[], oneToManyModeField: string, oneToManyModeEntityDescriptor: EntityDescriptor, oneToManyModeCachedId: any) {
        if (oneToManyModeField === "detectedBy" || oneToManyModeField === "equipmentResource") {
            filters!.push(Filter.createComposed(FilterOperators.forComposedFilter.or, [
                Filter.create("detectedBy", FilterOperators.forNumber.equals, oneToManyModeCachedId),
                Filter.create("equipmentResource", FilterOperators.forNumber.equals, oneToManyModeCachedId),
            ]));
        } else {
            super.addOneToManyModeFilters(filters, oneToManyModeField, oneToManyModeEntityDescriptor, oneToManyModeCachedId);
        }
    }

}

const DetectionEventTablePageRRC = ReduxReusableComponents.connectRRC(EntityTablePageState, EntityTablePageReducers, DetectionEventTablePage);
